// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"8cd4cb3e","125":"90bb4485","179":"0182a3e8","207":"ff8beb02","594":"aa6ab9ab","659":"16a45ec5"}[chunkId] + ".js";
};